import { render, staticRenderFns } from "./showArticle.vue?vue&type=template&id=20fb5353&scoped=true"
import script from "./showArticle.vue?vue&type=script&lang=js"
export * from "./showArticle.vue?vue&type=script&lang=js"
import style0 from "./showArticle.vue?vue&type=style&index=0&id=20fb5353&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb5353",
  null
  
)

export default component.exports